import { Divider, Drawer, Row, Col, Slider, Space, Input, Tooltip, Checkbox, Select } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import CalendarUI from "../../UI/CalendarUI";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import BMInput from "../../comps/BMInput";
import ColourPicker from "../../../globals/styles/ColourPicker";
import PresetPicker from "../../../globals/styles/PresetPicker";
import FontPicker from "../../../globals/styles/FontPicker";
import Upcoming from "../../UI/Upcoming";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import { PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import { tt_evu_padding_x, tt_evu_padding_y, tt_name_block_warning } from "../../../utils/Utils";
import LinkPicker from "../../../globals/styles/LinkPicker";
import CategorySelector from "../../UI/CategorySelector";

export default function EventsCalendarUpcoming(props) {

    const { view = "desktop" } = props;
    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [template, setTemplate] = useTemplate();
    const [content, setContent] = useState(props.content);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        width = 500,
        calendar_colour = 0,
        background_colour = 0,
        highlight_colour = 0,
        active_colour = 0,
        text_colour = 0,
        date_colour = 0,
        padding_x = 0,
        padding_y = 0,
        font = 0,
        title_preset = 0,
        description_preset = 0,
        date_preset = 0,
        limit = 2,
        button_type = 0,
        button_label = "View Events",
        button_align = "center",
        link_id = 0,
        display_titles = false,
        calendar_gap = 0,

        // New
        date_bar_preset = 0,
        day_preset = 0,
        border_colour = 0,
        day_border_colour = 0,
        calendar_header_colour = 0,
        weekdays_background_colour = 0,
        prev_next_background_colour = 0,

        categories = [],
        display_categories = false,

    } = data;

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const marks = {
        300: <small>300px</small>,
        500: <small>500px</small>,
        900: <small>900px</small>,
        1200: <small>1200px</small>,
    };

    
    const gapMarks = {
        0: <small>0px</small>,
        50: <small>50px</small>,
        100: <small>100px</small>,
    };


    const drawRender = () => {
        let _bgStyle = {
            background: getColor(background_colour, template),
            padding: padding_y + "px " + padding_x + "px"

        }
        let _wrapperStyle = {
            maxWidth: "100%",
        }
        let _calstyle = {}
        if (border_colour) {
            _calstyle.border = "1px solid " + getColor(border_colour, template, "#000");
        }

        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={_bgStyle}>
                    <div style={_wrapperStyle}>
                        <Row gutter={[20, 40]} style={{ "flexWrap": (view === "desktop") ? "nowrap" : "wrap", "gap": (view === "desktop" ? calendar_gap + "px" : "0") }}>
                            <Col flex={(width + "px")}>
                                <div style={_calstyle} className={"bm-font-" + font} >
                                    <CalendarUI
                                        display_titles={display_titles}
                                        display_categories={display_categories}
                                        active_colour={active_colour}
                                        highlight_colour={highlight_colour}
                                        text_colour={text_colour}
                                        calendar_colour={calendar_colour}
                                        categories={categories}
                                        date_bar_preset={date_bar_preset}
                                        day_preset={day_preset}
                                        calendar_header_colour={calendar_header_colour}
                                        weekdays_background_colour={weekdays_background_colour}
                                        prev_next_background_colour={prev_next_background_colour}
                                        day_border_colour={day_border_colour}
                                    />
                                </div>
                            </Col>
                            <Col flex="auto">
                                <Upcoming
                                    view={view}
                                    categories={categories}
                                    link_id={link_id}
                                    highlight_colour={highlight_colour}
                                    text_colour={text_colour}
                                    date_colour={date_colour}
                                    title_preset={title_preset}
                                    description_preset={description_preset}
                                    date_preset={date_preset}
                                    limit={limit}
                                    button_label={button_label}
                                    button_type={button_type}
                                    button_align={button_align}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_evu_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_evu_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                    <div></div>
                </div>
                <div className="shim" /> <div className="shim" />
                {/* FONT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CALENDAR FONT</Divider>
                <FontPicker value={font} onChange={(e) => setData({ ...data, "font": e })} />
                <div className="shim" /> <div className="shim" />
                {/* WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CALENDAR WIDTH</Divider>
                <Slider defaultValue={width} onChange={(e) => setData({ ...data, "width": e })} marks={marks} min={300} max={1248} />
                <div className="shim" /> <div className="shim" />
                {/* GAP */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CALENDAR GAP</Divider>
                <Slider defaultValue={calendar_gap} onChange={(e) => setData({ ...data, "calendar_gap": e })} marks={gapMarks} min={0} max={100} />
                <div className="shim" /> <div className="shim" />
                {/* CATEGORIES */}
                {(window.sitesettings.using_events_v2 && <>
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT CATEGORIES</Divider>
                    <CategorySelector value={categories} onChange={(e) => setData({ ...data, "categories": e })} />
                    <div className="shim" /> <div className="shim" />
                </>
                )}

                {/* SHOW TITLES */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DAY CELL DISPLAY</Divider>
                <Select value={(display_titles) ? "titles" : (display_categories) ? "categories" : "dots"} onChange={(e) => {
                    switch (e) {
                        case "titles":
                            setData({ ...data, "display_titles": true, "display_categories": false })
                            break;
                        case "categories":
                            setData({ ...data, "display_titles": false, "display_categories": true })
                            break;
                        default: // dots
                            setData({ ...data, "display_titles": false, "display_categories": false })
                            break;
                    }
                }} style={{ "width": "100%" }}>
                    <Select.Option value="dots"><small>Show Dots</small></Select.Option>
                    <Select.Option value="titles"><small>Show Titles <em>(space permitting)</em></small></Select.Option>
                    <Select.Option value="categories"><small>Show Categories <em>(space permitting)</em></small></Select.Option>
                </Select>

                {/* <Checkbox checked={display_titles} onChange={(e) => setData({ ...data, "display_titles": e.target.checked })} ><small>Show  <em style={{ "opacity": "0.6" }}>(large calendars only)</em></small></Checkbox> */}
                <div className="shim" /> <div className="shim" />

                {/* DATE PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DATE PRESET</Divider>
                <PresetPicker value={date_bar_preset} onChange={(e) => setData({ ...data, "date_bar_preset": e })} />
                <div className="shim" /> <div className="shim" />

                {/* DAY PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DAY PRESET</Divider>
                <PresetPicker value={day_preset} onChange={(e) => setData({ ...data, "day_preset": e })} />
                <div className="shim" /> <div className="shim" />

                {/* CALENDAR BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CALENDAR BACKGROUND COLOUR</Divider>
                <ColourPicker allow_none value={calendar_colour} onChange={(_v) => setData({ ...data, "calendar_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* CALENDAR BORDER COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CALENDAR BORDER COLOUR</Divider>
                <ColourPicker allow_none value={border_colour} onChange={(_v) => setData({ ...data, "border_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* DAY BORDER COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DAY BORDER COLOUR</Divider>
                <ColourPicker allow_none value={day_border_colour} onChange={(_v) => setData({ ...data, "day_border_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* DATE BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DATE BACKGROUND COLOUR</Divider>
                <ColourPicker allow_none value={calendar_header_colour} onChange={(_v) => setData({ ...data, "calendar_header_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* WEEKDAY BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">WEEKDAY BACKGROUND COLOUR</Divider>
                <ColourPicker allow_none value={weekdays_background_colour} onChange={(_v) => setData({ ...data, "weekdays_background_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* PREV/NEXT MONTH CELL COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PREV/NEXT MONTH COLOUR</Divider>
                <ColourPicker allow_none value={prev_next_background_colour} onChange={(_v) => setData({ ...data, "prev_next_background_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* HIGHLIGHT COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DAY COLOUR</Divider>
                <ColourPicker allow_none value={highlight_colour} onChange={(_v) => setData({ ...data, "highlight_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* ACTIVE CELL COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT DAY COLOUR</Divider>
                <ColourPicker allow_none value={active_colour} onChange={(_v) => setData({ ...data, "active_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* TITLE PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT TITLE PRESET</Divider>
                <PresetPicker value={title_preset} onChange={(e) => setData({ ...data, "title_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* DESCRIPTION PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT DATE PRESET</Divider>
                <PresetPicker value={date_preset} onChange={(e) => setData({ ...data, "date_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* DESCRIPTION PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT DESCRIPTION PRESET</Divider>
                <PresetPicker value={description_preset} onChange={(e) => setData({ ...data, "description_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* DATE COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DATE COLOUR</Divider>
                <ColourPicker allow_none value={date_colour} onChange={(_v) => setData({ ...data, "date_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* LIMIT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LIMIT</Divider>
                <BMInput number min={1} max={5} value={limit} onChange={(_v) => setData({ ...data, "limit": _v })} />
                {/* BUTTON LABEL */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON LABEL</Divider>
                <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "button_label": e.target.value })} value={button_label} placeholder="Label..." />
                <div className="shim" /> <div className="shim" />
                {/* BUTTON TYPE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON TYPE</Divider>
                <ButtonPicker value={button_type} onChange={(e) => setData({ ...data, "button_type": e })} />
                <div className="shim" /> <div className="shim" />
                {/* ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON ALIGN</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space>
                        <div><PicLeftOutlined onClick={() => setData({ ...data, "button_align": "left" })} style={{ "color": (button_align === "left") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicCenterOutlined onClick={() => setData({ ...data, "button_align": "center" })} style={{ "color": (button_align === "center") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicRightOutlined onClick={() => setData({ ...data, "button_align": "right" })} style={{ "color": (button_align === "right") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />
            </>
        )
    }



    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}